import iconError from "../assets/images/icon-error.svg";
import iconInfo from "../assets/images/icon-info-blue.svg";
import iconSuccess from "../assets/images/icon-success.svg";
import iconWarning from "../assets/images/icon-warning.svg";

const stylingMap = {
  error: {
    icon: {
      background: `url(${iconError})`,
      height: 24
    },
    wrapper: {
      background: "#fff8f8",
      border: "solid 1px #c0212c"
    }
  },
  warning: {
    icon: {
      background: `url(${iconWarning})`,
      height: 20
    },
    wrapper: {
      background: "#fff9e1",
      border: "solid 1px #fcae00"
    }
  },
  info: {
    icon: {
      background: `url(${iconInfo})`,
      height: 24
    },
    wrapper: {
      background: "#f7faff",
      border: "solid 1px #196097"
    }
  },
  success: {
    icon: {
      background: `url(${iconSuccess})`,
      height: 24
    },
    wrapper: {
      background: "#e8fcf5",
      border: "solid 1px #157e77"
    }
  }
};

const Alert = ({ children, style }) => {
  const { icon, wrapper } = stylingMap[style];
  const warningImageStyling = {
    marginRight: 8,
    minWidth: 24,
    ...icon,
    backgroundRepeat: "no-repeat",
    alignItems: "center"
  };
  return (
    <div
      style={{
        borderRadius: "4px",
        padding: "12px 16px",
        display: "flex",
        ...wrapper,
        alignItems: "center"
      }}
    >
      <div style={warningImageStyling} />
      <div style={{ flexGrow: "1" }}>{children}</div>
    </div>
  );
};

export default Alert;



// WEBPACK FOOTER //
// ./components/Alert.js